var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrap"},[_c('HeroSection',{on:{"play-film":_vm.scrollToFilm}}),_c('QuotesSection'),_c('InfrastructureSection'),_c('ConsumerModelSection'),_c('SolutionsSection'),_c('FilmSection',{ref:"filmSection"}),_c('ProjectSection'),_c('News'),_c('DiscussSection'),_c('VFooter'),_c('QuestionPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }